import { cn } from "@hero-app/lib/utils";

// Shared title + subtitle block. Used by the page header and the table header.
//  - size   sm | md | lg → typographic scale
//  - inline boolean       → title and subtitle on one line (vs stacked)
// Defaults (md / stacked) reproduce the original headings.
export type SectionHeadingSize = "sm" | "md" | "lg";

const SECTION_HEADING_SIZE: Record<
  SectionHeadingSize,
  { title: string; subtitle: string; gap: string }
> = {
  sm: { title: "text-[12px]", subtitle: "text-[10px]", gap: "mt-0.5" },
  md: { title: "text-[14px]", subtitle: "text-[11px]", gap: "mt-0.5" },
  lg: { title: "text-[17px]", subtitle: "text-[12px]", gap: "mt-1" },
};

export function SectionHeading({
  title,
  subtitle,
  size = "md",
  inline = false,
  as = "h2",
}: {
  title: string;
  subtitle?: string;
  size?: SectionHeadingSize;
  inline?: boolean;
  as?: "h1" | "h2";
}) {
  const s = SECTION_HEADING_SIZE[size];
  const Title = as;
  const titleEl = (
    <Title className={cn("font-medium leading-none tracking-[-0.4px] text-[#1a2026]", s.title)}>
      {title}
    </Title>
  );

  if (inline) {
    return (
      <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
        {titleEl}
        {subtitle && <p className={cn("text-black/30", s.subtitle)}>{subtitle}</p>}
      </div>
    );
  }

  return (
    <div>
      {titleEl}
      {subtitle && <p className={cn("text-black/30", s.gap, s.subtitle)}>{subtitle}</p>}
    </div>
  );
}
